export const getListingType = (listing) =>
  listing?.attributes?.publicData?.listingType;
